module.exports = __webpack_public_path__ + "youtube.webp?721a8f7b4041d32e2f3540920eb83bca";